module.exports = __webpack_public_path__ + "img/pHD-5000.faa53ca3.png";